import { useCallback, useMemo } from "react";
import { useStorageListener } from "../useStorageListener/useStorageListener";

type JobAlertHistoryEvent = Record<string, string | number>;

const encoder = (value: JobAlertHistoryEvent[]): string => {
    try {
        return JSON.stringify(value);
    } catch (error) {
        console.error("useJobAlertHistory failed to encode:", error);
        return String(value);
    }
};

const decoder = (value?: string|null): JobAlertHistoryEvent[] | string => {
    try {
        return JSON.parse(value ?? "") as JobAlertHistoryEvent[];
    } catch (error) {
        console.error("useJobAlertHistory failed to decode:", error);
        return String(value);
    }
};

const useJobAlertHistory = (currentEvent?: JobAlertHistoryEvent) => {
    const { storeValue, value } = useStorageListener({
        decoder,
        defaultValue: [],
        encoder,
        storageKey: "jobAlertHistory",
    });

    const append = useCallback((entry: JobAlertHistoryEvent) => {
        storeValue([
            ...(value || []),
            entry
        ]);
    }, [storeValue, value]);

    const hasAlert = useMemo<boolean>(() => {
        if (!currentEvent || !value?.length) {
            return false;
        }
        const currentEntries = Object.entries(currentEvent);
        return value.some((entry: JobAlertHistoryEvent) => {
            return Object.keys(entry).length === currentEntries.length
                && currentEntries.every(([key, value]) => entry[key] === value);
        });
    }, [currentEvent, value]);

    return { append, hasAlert, value };
};

export { useJobAlertHistory as default };
export type { JobAlertHistoryEvent };
